export const baseSpaDay = {
  id: 20,
  categories: [],
  name: 'Express Day',
  image: null,
  price: {
    amount: 7500,
    currencyCode: 'gbp',
  },
  description:
    'The perfect treat to unwind and take advantage of the spa facilities. \r\n\r\nIncludes :  55 minute Hot Stones Massage',
  termsAndConditions: null,
  numberOfGuests: 1,
  durationText: null,
  gender: null,
  displayOrder: 9999,
  crossSellObjects: [],
  upSell: null,
  supportsTimeslots: false,
};
